import { Shadow, Text, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React, { Fragment, ReactNode } from 'react';
import { useRecoilValue } from 'recoil';

import { homeGlobalState } from '../../../../../../store/home/capture/atom';

export declare namespace FundraisingAnalysisTooltipTypes {
  interface PayloadData {
    name: string;
    color: string;
    payload: any;
  }

  interface Props {
    active?: boolean;
    label?: string;
    payload?: PayloadData[] | any[];
    nameMap: Map<string, string>;
  }
}

export const FundraisingAnalysisTooltip: React.FC<FundraisingAnalysisTooltipTypes.Props> = ({
  payload,
  nameMap,
}) => {
  const { valueVisibility } = useRecoilValue(homeGlobalState);

  if (!payload || !payload.length) {
    return null;
  }

  const month = payload[0].payload.referenceDateFullNormalized;
  const values: ReactNode[] = [];
  const items = payload.map((item: FundraisingAnalysisTooltipTypes.PayloadData) => {
    const formattedValue = item.payload[`${item.name}Normalized`];

    if (!formattedValue) {
      return <Fragment key={item.name} />;
    }

    values.push(
      <Text
        key={item.name}
        variant="semibold"
        fontSize={Typography['fontsize.xs']}
        letterSpacing={valueVisibility ? undefined : Typography['bullet.spacing']}>
        {valueVisibility ? formattedValue : Typography['bullet.sequence']}
      </Text>
    );

    return (
      <HStack alignItems="center" key={item.name} space={Spacing['inline.nano']}>
        <Box w="8px" h="8px" background={item.color} borderRadius="full" />
        <Text variant="semibold" fontSize={Typography['fontsize.xs']} textTransform="capitalize">
          {nameMap.get(item.name)?.toLowerCase()}
        </Text>
      </HStack>
    );
  });

  return (
    <Shadow level={1} testID="shadow">
      <VStack
        background={Color['neutral.white']}
        p={Spacing['inset.xs']}
        space={Spacing['inset.nano']}
        minWidth="150px">
        <Text fontSize={Typography['fontsize.xs']} textTransform="capitalize">
          {month}
        </Text>
        <HStack space={Spacing['inset.nano']}>
          <VStack space={Spacing['inset.quarck']}>{items}</VStack>
          <VStack space={Spacing['inset.quarck']} alignItems="flex-end">
            {values}
          </VStack>
        </HStack>
      </VStack>
    </Shadow>
  );
};
